module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/anchor-right-down-3114adb02cf417f2be494c620c8c1550.svg";